import React from 'react'

import { useIsEmbedded } from '../embed/child/useIsEmbedded'
import { cn } from '../lib/utils'

export function Container({ children, className }: { children: React.ReactNode; className?: string }) {
  const isEmbed = useIsEmbedded()
  return <div className={cn('mx-auto w-full max-w-7xl px-4', className, isEmbed && 'px-0')}>{children}</div>
}
